module.exports = __webpack_public_path__ + "logo_amazonpay-primary-fullcolor-positive.73a24d74.svg";